import { useUser } from "@/composables/user";
import { createError404Link } from "@/router/linkFactories";
import type { Right } from "@/services/user";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

/**
 * !!!
 * There is some bug in async callings.
 * Sometimes createError404Lin() is called before user rights are loaded.
 */
export const checkUserHasRight = (requestedRight: Right) => {
  return async (_: RouteLocationNormalized, __: RouteLocationNormalized, next: NavigationGuardNext) => {
    await checkUserOnInitialPageLoad();
    const { hasRight } = useUser();
    if (!hasRight(requestedRight)) {
      next(createError404Link());
    } else {
      next();
    }
  };
};
